<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                formatForm: () => import('../forms/FormatForm'),
                testGroupForm: () => import('../forms/TestGroupForm'),
                unitForm: () => import('../forms/UnitForm'),
                fields: [
                    { type: 'text', text: 'Name', value: 'name', rules: [v => !!v || 'Name is required', v => !(v && v.length > 100) || 'Name must be less than 100 characters'], isRequired: true, maxLength: 100 },
                    { type: 'autocomplete', text: 'Test Group', value: 'testGroupId', rules: [v => !!v || 'Test Group is required'], isRequired: true, form: () => import('./TestGroupForm'), apiMethod: 'TestGroups', claim: 'TestGroups' },
                    { type: 'autocomplete', text: 'Unit', value: 'unitId', rules: [v => !!v || 'Unit is required'], isRequired: true, form: () => import('./UnitForm'), apiMethod: 'Units', claim: 'Units' },
                    { type: 'autocomplete', text: 'Format', value: 'formatId', rules: [v => !!v || 'Format is required'], isRequired: true, form: () => import('./FormatForm'), apiMethod: 'Formats', claim: 'Formats' },
                ],
                apiMethod: 'Tests',
                formTitle: 'Test',
            }
        },
    };
</script>
